import { render, staticRenderFns } from "./WBtnLock.vue?vue&type=template&id=fe2f6a32&scoped=true&"
import script from "./WBtnLock.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnLock.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2f6a32",
  null
  
)

export default component.exports